export enum Types {
	CHANGE_URL_REQUEST = '@E-CPF/CHANGE_URL_REQUEST',
	CHANGE_URL_CLEAR = '@E-CPF/CHANGE_URL_CLEAR',
}

export interface ChangeUrl {
	data: boolean | null;
}
